import { graphql } from 'gatsby';
import React from 'react';

import { BlogQuery } from '../../../graphql-types';
import { TPageProps } from '../../page-props';
import BlogPage from '../../templates/blog';

export default (props: TPageProps<BlogQuery>) => <BlogPage {...props} />;

export const query = graphql`
  query Blog($lang: String) {
    allPrismicBlogPostTheme(
      filter: { lang: { eq: $lang } }
      sort: { data: { title: { text: ASC } } }
    ) {
      ...PrismicBlogPostThemes
    }
    allPrismicBlogPost(
      filter: { lang: { eq: $lang } }
      sort: { data: { publication_date: DESC } }
    ) {
      ...PrismicBlogPosts
    }
    prismicBlog(lang: { eq: $lang }) {
      _previewable
      lang
      data {
        ...BlogData
      }
    }
  }
`;
